module.exports = __webpack_public_path__ + "static/media/neutral-progress-bar-icon.4ad0ad28.svg";